import React from 'react';
import clsx from 'clsx';
import type { SclaStepState } from 'features/scla/utils/sectionStatus';
import styles from './SclaStepMark.module.scss';

interface ISclaStepMarkProps {
  state: SclaStepState;
  index: number;
  compact?: boolean;
}

export default function SclaStepMark({
  state,
  index,
  compact = false,
}: ISclaStepMarkProps) {
  if (state === 'optional') {
    return (
      <span className={clsx(styles.mark, styles.empty, compact && styles.compact)}>
        {index + 1}
      </span>
    );
  }

  const started = state === 'started';
  return (
    <span
      className={clsx(styles.mark, styles[state], compact && styles.compact)}
      title={started ? 'Started, not complete' : undefined}
    >
      {state === 'complete' ? '✓' : index + 1}
    </span>
  );
}
